var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocumentCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    x: 0.5,
    y: 0.5,
    fill: "#D7EFFF",
    stroke: "#003F93",
    rx: 20.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#003F93",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M26 15H16M24 19h-8M26 23H16M21 27h-5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    x: 12,
    y: 9,
    stroke: "#003F93",
    strokeWidth: 2,
    rx: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentCircle);
export default __webpack_public_path__ + "static/media/icon-document-circle.08ec545647c65bad457ac2df91f756b7.svg";
export { ForwardRef as ReactComponent };